import type { LobbyInfo } from "../networking/SignalingClient";

export class LobbyBrowser {
  constructor(private readonly onJoin: (code: string) => void) {}

  showLoading(): void {
    this.container.innerHTML = '<p class="empty-state">Scanning frequencies…</p>';
  }

  showUnavailable(): void {
    this.container.innerHTML = '<p class="empty-state">The signaling service did not answer.</p>';
  }

  showIdle(): void {
    this.container.innerHTML = '<p class="empty-state">Press Refresh to scan online rooms, or enter a room code.</p>';
  }

  render(lobbies: LobbyInfo[]): void {
    this.container.innerHTML = lobbies.length > 0
      ? lobbies.map(lobbyRow).join("")
      : '<p class="empty-state">No rooms are waiting for players. Create one and invite a rival.</p>';
    for (const row of this.container.querySelectorAll<HTMLElement>("[data-lobby-code]")) {
      row.addEventListener("click", () => this.onJoin(row.dataset.lobbyCode ?? ""));
    }
  }

  private get container(): HTMLElement {
    return document.getElementById("lobby-list")!;
  }
}

const lobbyRow = (lobby: LobbyInfo): string => `
  <button class="lobby-row" data-lobby-code="${lobby.code}" aria-label="Request to join ${escapeHtml(lobby.name)}, room ${lobby.code}">
    <span class="lobby-signal" aria-hidden="true"></span>
    <span class="lobby-summary">
      <b>${escapeHtml(lobby.name)}</b>
      <small><strong>${lobby.code}</strong><span>${modeLabel(lobby.mode)}</span><span>${mapLabel(lobby.mapId)}</span>${distanceLabel(lobby.distanceKm)}</small>
    </span>
    <span class="lobby-capacity"><b>${lobby.peers.length}/${lobby.maxPlayers}</b><small>Players</small></span>
    <span class="lobby-action">Request<svg viewBox="0 0 18 18" aria-hidden="true"><path d="M3 9h11M10 5l4 4-4 4"/></svg></span>
  </button>`;

const modeLabel = (mode: LobbyInfo["mode"]): string => mode === "teams" ? "Team battle" : "Deathmatch";
const mapLabel = (mapId: string): string => ({ foundry: "Ash Foundry", catacomb: "Neon Catacomb", spire: "Broken Spire" })[mapId] ?? "Unknown map";
const distanceLabel = (distanceKm: number | undefined): string => Number.isFinite(distanceKm)
  ? `<span>${Math.max(1, Math.round(distanceKm!))} km away</span>`
  : "";
const escapeHtml = (value: string): string => value.replace(/[&<>'"]/g, (character) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", "'": "&#039;", '"': "&quot;" })[character]!);
